<template>
  <div>
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">合同名称</p>
        <el-input v-model="contractName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">历史合同名称</p>
        <el-input v-model="relContractName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">合同类别</p>
        <el-select
            v-model="category"
            style="width: 70%;"
            filterable clearable>
              <el-option
              v-for="item in contractType"
              :key="item.id"
              :label="item.label"
              :value="item.label"/>
            </el-select>
      </div>
      <div class="btnDiv">
        <el-button class="searchBtn" style="margin-left: -100px;" type="primary" @click="getTableList">查 询</el-button>
        <el-button @click="addContrat()"><i class="el-icon-upload2" ></i>上传合同</el-button>
      </div>
    </div>
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" :highlight-current-row="false"
          :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <el-table-column prop="filingName" label="合同名称">
            <template slot-scope="scope">
                  <el-link type="primary" @click="handlePreview(scope.row)">{{scope.row.filingName}}</el-link>
              </template>
          </el-table-column>
          <el-table-column prop="category" label="合同类别"></el-table-column>
          <el-table-column prop="contractValidityStartDate" label="合同有效期开始时间"></el-table-column>
          <el-table-column prop="contractValidityEndDate" label="合同有效期结束时间"></el-table-column>
          <el-table-column prop="filingName" label="历史合同名称">
            <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.contractHistoryList" :key="index">
                  <el-link type="primary" @click="handlePreview(item)">{{item.filingName}}</el-link>
                </div>
              </template>
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间"></el-table-column>
          <el-table-column label="操作" width="240">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="downloadCertification(scope.row)" type="text" size="small">下载查看
              </el-button>
              <el-popconfirm
                v-if="roleName === '办公室'"
                title="确认删除该合同吗？"
                style="margin-left: 15px;"
                @confirm="deleteFun(scope.row)"
              >
                <el-button slot="reference" class="tableBtn" type="text" size="small">删除
                </el-button>
              </el-popconfirm>
              <el-upload style="display: inline;margin-left: .2rem" ref="uploadFile" action=""
                :http-request="(param) => httpRequestHistory(param, scope.row)" :on-change="handleChange" :on-remove="handleRemove" :file-list="fileList"
                show-file-list accept=".pdf" :limit="1">
                
                <el-link type="primary">上传历史合同</el-link>
                <!-- <el-button style="width: 1.5rem;margin-left: -50px;"><i class="el-icon-upload2"></i></el-button> -->
              </el-upload>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody"></el-pagination>
        <el-dialog :visible="elDialogShow" center  :before-close="closeContrat" title="上传合同">
          <el-form ref="addFormRef" :model="addForm" :rules="rules" class="formDiv">
          <el-form-item label="合同类别" label-width="1.2rem" prop="category" class="formItem">
            <el-select
            v-model="addForm.category"
            style="width: 100%"
            filterable clearable>
              <el-option
              v-for="item in contractType"
              :key="item.id"
              :label="item.label"
              :value="item.label"/>
            </el-select>
          </el-form-item>
          <el-form-item label="合同有效期" label-width="1.2rem" class="formItem">
            <el-date-picker
              v-model="addForm.time"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="上传合同" label-width="1.2rem" prop="file" class="formItem">
                 <el-upload style="display: block;margin-left: 30%;"  ref="uploadFile" action=""
                  :http-request="httpRequest" :on-change="handleChange" :on-remove="handleRemove" :file-list="fileList"
                  show-file-list accept=".pdf" :limit="1">
                    <el-button style="width: 1.5rem;margin-left: -50px;"><i class="el-icon-upload2"></i>上传附件</el-button>
                </el-upload>
          </el-form-item> -->
          <el-form-item label="附件上传" prop="file" label-width="1.2rem">
            <el-upload  action="" :http-request="httpRequest" :file-list="addForm.file" :before-upload="beforeUpload"
              :on-preview="handlePictureCardPreview" :on-remove="handleRemove" show-file-list accept=".pdf" :limit="1">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">最多上传一个PDF附件！</div>
            </el-upload>
          </el-form-item>
          <el-row style="text-align:center">
            <el-button style="width: 1.5rem;" type="primary" @click="submit">提交</el-button>
          </el-row>
          </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { fileDownload } from '../../api/user'
import { addContractHistory, queryContractHistory, uploadContractHistory, deleteContractHistory } from '@/api/contract'
import base from '@/utils/index'

export default {
  name: 'historyContract',
  data () {
    return {
      fileList: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      elDialogShow: false,
      contractName: '',
      category: '',
      relContractName: '',
      tableData: [],
      contractType: [
        {
          label: '租赁类'
        },
        {
          label: '工程类'
        },
        {
          label: '配套类'
        },
        {
          label: '审计类'
        },
      ],
      tableColumns: [
        {
          prop: 'filingName',
          label: '合同名称',
          width: '200'
        },
        {
          prop: 'contractHistorvList',
          label: '历史合同名称',
          width: '200'
        },
        {
          prop: 'createTime',
          label: '上传时间'
        }
      ],
      addForm: {
        file: [],
        category: '',
        time: []
      },
      rules: {
        file: [{ required: true, message: '请上传', trigger: 'change' }],
        time: [{ required: true, message: '请选择', trigger: 'change' }],
        category: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      roleName: ''
    }
  },
  created () {
    const baseFunc = base()
    this.roleName = baseFunc.getLocalStorage('userInfo_roleName')
    // console.log('rolename', this.roleName)
  },
  mounted () {
    this.getTableList()
  },
  methods: {
    // 下载
    async downloadCertification (row) {
      let res = await fileDownload(row.filingUrl)
      let blob = new Blob([res.data], { type: res.data.type })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = row.filingName + '.pdf'
      link.click()
    },
    handlePictureCardPreview(file) {
      console.log(file);
      // window.location.href = file
    },
    addContrat() {
      this.elDialogShow = true
    },
    closeContrat() {
      this.elDialogShow = false
      this.addForm = {
        file: [],
        category: '',
        time: []
      }
      this.$refs['addFormRef'].resetFields();
    },
    submit() {
      this.$refs.addFormRef.validate(async(vaild) => {
      if (vaild) {
        let fd = new FormData()
        fd.append('file', this.addForm.file[0])
        fd.append('category', this.addForm.category)
        fd.append('contractValidityEndDateStr', this.addForm.time.length > 0 ? this.addForm.time?.[1] : '')
        fd.append('contractValidityStartDateStr', this.addForm.time.length > 0 ? this.addForm.time?.[0] : '')
        let res = await addContractHistory(fd)
          const { code, message } = res
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('上传成功！')
          this.closeContrat()
          this.getTableList()
        }
      })
    },
    beforeUpload (file) {
      if (this.addForm.file.length === 1) {
        this.$message.warning('只允许上传一个附件')
        return false
      }
      // let name = file.name
      // if (name.length > 60) {
      //   this.$message.warning('附件名称不能超过60个字符')
      //   return false
      // }
    },
    // 上传文件
    async httpRequest (param) {
      let file = param.file
      if (this.addForm.file.length !== 1) {
        this.addForm.file[0] = file
      } else {
        this.$message.warning('只能上传一个附件')
      }
      // let fd = new FormData()
      // fd.append('file', file)
      // // fd.append('contractNumber', this.fileId)
      // let res = await addContractHistory(fd)
      // if (res.code === 0) {
      //   this.$message({
      //     message: '上传成功',
      //     type: 'success'
      //   })
      //   await this.getTableList()
      //   this.fileList = []
      //   this.isFileSelected = false
      // } else {
      //   this.$message.error(res.message)
      // }
    },
    async httpRequestHistory (param, row) {
      console.log(row);
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      fd.append('relFilingNumber', row.filingNumber)
      fd.append('contractTags', row.contractTags)
      let res = await uploadContractHistory(fd)
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        await this.getTableList()
        this.fileList = []
        this.isFileSelected = false
      } else {
        this.$message.error(res.message)
      }
    },
    handleChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file && fileList.length) {
        this.isFileSelected = true
      }
    },
    handleRemove (file, fileList) {
      if (!fileList.length) {
        this.addForm.file = []
      }
    },
    handleCurrentChange (page) {
      this.currentPage = page
      this.getTableList()
    },
    async getTableList () {
      const { code, result: { total, records } } = await queryContractHistory({
        contractName: this.contractName,
        relContractName: this.relContractName,
        category: this.category,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (code === 0) {
        this.tableData = records.filter(item => {
          item.filingName = item.filingName.replace('.pdf', '')
          return item.contractNumber === ''
        })
        this.totalCount = total
      }
    },
    async handlePreview(file) {
      let fileItem = { ...file, fileName: file.filingUrl }
      let componentProps = {
          curStatus: 'pdf',
          pdfFile: fileItem
        }
        let dialogProps = {
          title: '文件预览',
          width: '80%',
          footer: true
        }
        this.$dialog('', componentProps, dialogProps)
    },
    deleteFun (row) {
      if (!row) return
      const { id } = row
      deleteContractHistory({ id }).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTableList()
        }
      })
    }
    }
  }
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}
.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  display: flex;
  justify-content: flex-start; /*两端对齐，子元素之间有间隙*/
  flex-flow: row wrap; /*子元素溢出父容器时换行*/
  .stateDiv {
    width: 3.7rem;
    margin-top: 0.14rem;
  }
  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }
  .stateDivText {
    margin-top: 0.14rem;
  }
  .inputDiv {
    width: 2.2rem;
    float: left;
  }
  .btnDiv {
    margin-left: 1.3rem;
  }
  .searchBtn {
    margin-top: 0.16rem;
    margin-left: .3rem;
  }
}
.table {
  margin-top: .5rem;
  margin-left: .3rem;
  text-align: center;
  width: 14.8rem;
  .searchList {
  }
  .paginationBody {
    margin-top: .1rem;
  }
}
.formItem {
  // width: 3.2rem;
}
/deep/ .el-dialog {
  width: 40% !important;
}
.previewDialogDiv {
  /deep/ .el-dialog {
    width: 70% !important;
  }
}
</style>
